const EmailEvents = Object.freeze({ 
    Deployed: 20, 
    Bounced: 21, 
    Opened: 23, 
    Unsubscribed: 24, 
    Clicked: 27
}); 
  
export default EmailEvents;